import React from 'react'
import styled, { css } from 'styled-components'

import { Field, FieldProps } from 'formik'
import { Variables } from '../styles/Variables'

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    // Hide checkbox visually but remain accessible to screen readers.
    // Source: https://polished.js.org/docs/#hidevisually
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`

const Icon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    opacity: 0;
`

export const CheckboxContainer = styled.div`
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 14px;
`

const checkedStyles = css`
    background-color: white;

    ${Icon} {
        opacity: 1;
    }
`
const uncheckedStyles = css`
    background-color: transparent;
`

const darkStyle = css`
    background-color: black;
    svg path {
        stroke: white;
    }
`

export const StyledCheckbox = styled.div`
    background: ${Variables.color.white};
    display: inline-block;
    border: 1px solid ${Variables.color.white};
    border-radius: 0;
    height: 30px;
    width: 30px;
    min-width: 30px;
    background: none;
    color: ${Variables.color.cocoa};
    cursor: pointer;

    ${({ checked }) => (checked ? checkedStyles : uncheckedStyles)};

    ${({ darktheme, checked }) => darktheme && checked && darkStyle};
`

export const Label = styled.span`
    display: inline-block;
    vertical-align: middle;
    margin-left: 20px;
    cursor: pointer;
    font-weight: 300;
    font-size: 18px;
    line-height: 22px;
    font-family: ${Variables.font.body};
    color: ${Variables.color.white};
`

const LabelWrap = styled.label`
    display: flex;
    align-items: center;
`

const Checkbox = ({ name, label, disabled, darktheme }) => {
    return (
        <Field
            name={name}
            render={({ field }: FieldProps) => (
                <CheckboxContainer>
                    <LabelWrap>
                        <HiddenCheckbox checked={field.value} {...field} disabled={disabled} />
                        <StyledCheckbox checked={field.value} darktheme={darktheme}>
                            <Icon>
                                <svg
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect width="10" height="10" fill={Variables.color.pazola} />
                                </svg>
                            </Icon>
                        </StyledCheckbox>
                        <Label>{label}</Label>
                    </LabelWrap>
                </CheckboxContainer>
            )}
        />
    )
}

export default Checkbox
